import * as React from 'react';

import {LEAD_RESEARCH_AGENT} from '../helpers';
import {TeamAiAgent} from '../team-ai-agent';

type Props = {
    pageContext: string | null | undefined;
};

export function LeadResearchAgent(props: Props) {
    return (
        <TeamAiAgent
            agentKey={LEAD_RESEARCH_AGENT}
            onInitializeChatbot={() => {}}
            pageContext={props.pageContext}
        />
    );
}
